/**
 * AuroraStatusPill — visualizes `AuroraExportStatus` on a document row.
 *
 * Aurora delayed-indexing is FSR-invisible per Bible §Document Library, but
 * admin/Compliance users reviewing the library benefit from the indicator so
 * they can spot failed exports quickly.
 */

import { Pill } from '@/components/primitives';
import type { RdlDocumentStatus } from '@/hooks/useDocuments';

export interface AuroraStatusPillProps {
  status: RdlDocumentStatus;
}

const SPEC: Record<
  RdlDocumentStatus,
  { label: string; variant: 'ok' | 'warn' | 'err' | 'info' | 'muted' }
> = {
  exported: { label: 'Exported', variant: 'ok' },
  indexed: { label: 'Indexed', variant: 'info' },
  pending: { label: 'Pending', variant: 'warn' },
  failed: { label: 'Failed', variant: 'err' },
};

export function AuroraStatusPill({ status }: AuroraStatusPillProps): JSX.Element {
  const spec = SPEC[status];
  return <Pill variant={spec.variant}>{spec.label}</Pill>;
}
